import * as R from 'ramda';
import { compose, withStateHandlers } from 'recompose';

import { theme } from '../../../styles';
import { EditableItem } from './component';

const getErrorMessage = (fieldName, qty) =>
  `${fieldName} should be${fieldName === 'Title' ? ' min 2 and' : ''} max ${qty} symbols!`;

const noTitle = 'You must enter Title!';

const errorHelper = (errors = [], value, qty, fieldName) => {
  if (fieldName === 'Title') {
    if ((!value) && errors.indexOf(noTitle) === -1) {
      errors.unshift(noTitle);
    }
    if ((value) && errors.indexOf(noTitle) !== -1) {
      errors.splice(errors.indexOf(noTitle), 1);
    }
  }
  if (((fieldName === 'Title' && value.length < 2) || value.length > qty)
        && !errors.includes(getErrorMessage(fieldName, qty))) {
    return [...errors, getErrorMessage(fieldName, qty)];
  }
  if (errors.includes(getErrorMessage(fieldName, qty))
      && (fieldName === 'Title'
        ? value.length > 1 && value.length <= qty
        : value.length <= qty)) {
    return errors.filter(item => item !== getErrorMessage(fieldName, qty));
  }
  return errors;
};

export default compose(withStateHandlers(
  ({
    id,
    title = '',
    description = '',
    color = theme.colors.green,
    isEdit = false,
    isDefault = false,
    settingsType,
    onItemChange,
    onItemCreate,
    onItemRemove,
  }) => ({
    id,
    title,
    description,
    color,
    tempData: { color, title, description },
    isEdit,
    isDefault,
    settingsType,
    onItemChange,
    onItemCreate,
    onItemRemove,
  }),
  {
    handleClickEdit: () => () => ({ isEdit: true }),
    handleCancelEdit: ({ color, title, description }) => () => ({
      isEdit: false,
      tempData: { color, title, description },
      errors: [],
    }),
    handleSelectNewColor: ({ tempData }) => selectedColor => ({
      tempData: { ...tempData, color: selectedColor },
    }),
    handleSelectNewTitle: ({ tempData, errors }) => newTitle => ({
      tempData: {
        ...tempData,
        title: newTitle,
      },
      errors: errorHelper(errors, newTitle.trim(), 70, 'Title'),
    }),
    handleSelectNewDescription: ({ tempData, errors }) => newDescription => ({
      tempData: {
        ...tempData,
        description: newDescription,
      },
      errors: errorHelper(errors, newDescription.trim(), 300, 'Description'),
    }),
    handleSaveChanges: ({
      id, color, title, tempData, onItemChange, description,
    }) => () => {
      const prevData = { color, title, description };
      const changedData = Object.keys(tempData).reduce((acc, key) => ({
        ...acc,
        [key]: tempData[key].trim(),
      }), {});
      if (!R.equals(prevData, changedData)) onItemChange(id, changedData);
      return ({ isEdit: false });
    },
    handleItemCreate: ({
      color, title, tempData, onItemCreate, description,
    }) => () => {
      onItemCreate(tempData);
      return ({ isEdit: false, tempData: { color, title, description } });
    },
    handleItemRemove: ({
      id, color, title, onItemRemove, description,
    }) => () => {
      onItemRemove(id);
      return ({ isEdit: false, tempData: { color, title, description } });
    },
  },
))(EditableItem);



// WEBPACK FOOTER //
// ./src/components/editable-list/listItem/container.js